(ns ycweb.app.website.myaccount.addresses.list
  (:require
   [rum.core :as rum]
   [ycweb.app.website.myaccount.common :as awm.common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))


;; LIST ================================================================================================================
(rum/defc address-line
  [app-atom user-address-atom address-item]
  (let [default-billing-atom (rum/cursor-in user-address-atom [:user/billing-address :ent/uuid])
        default-delivery-atom (rum/cursor-in user-address-atom [:user/delivery-address :ent/uuid])

        {:address/keys [address country date-deleted]} address-item]
    (when-not date-deleted
      [:tr.yc-tr
       {:key (:ent/uuid address-item)}
       [:th.yc-th {:scope "row"}
        (if (< (count address) 60)
          address
          (str (subs address 0 60) "..."))
        (when-not (= (:country/code country) "ZA")
          [:div
           [:span
            {:class (u/bem :text-status [:warning])}
            [:b "Note:"] " We no longer ship outside of South Africa"]])]
       [:td
        {:class (u/bem :yc-td [:centered])}
        [:span
         {:class (u/bem :yc-td__faux-table [:120])
          :data-th "Default Billing"}
         [:span.yc-td__faux-td
          (input-forms/radio "" (:ent/uuid address-item) default-billing-atom
            {:inline true
             :change-fn #(grid/dispatch-action app-atom :web.myaccount.address/changedefaultbilling {:ent/uuid (:ent/uuid address-item)})})]]]
       [:td
        {:class (u/bem :yc-td [:centered])}
        [:span
         {:class (u/bem :yc-td__faux-table [:120])
          :data-th "Default Shipping"}
         [:span.yc-td__faux-td
          (input-forms/radio "" (:ent/uuid address-item) default-delivery-atom
            {:inline true
             :disabled (not (= (:country/code country) "ZA"))
             :change-fn #(grid/dispatch-action app-atom :web.myaccount.address/changedefaultdelivery {:ent/uuid (:ent/uuid address-item)})})]]]
       [:td
        {:class (u/bem :yc-td [:centered])}
        [:span
         {:class (u/bem :yc-td__faux-table [:120])
          :data-th "Options"}
         [:span.yc-td__faux-td
          [:a
           (merge
             ;;todo - redirect needed?
             (urlstate/href-props app-atom "myaccount" "addressedit" {:uuid (:ent/uuid address-item)})
             {:class (u/bem :icon-link :icon-block-link [:size-small] :tooltip [:top])
              :data-tooltip "Edit"})
           [:i {:class (u/bem :icon [:pencil :is-dark :inline])}]
           [:span.hidden-from-view "Edit address"]]
          [:a
           {:on-click #(grid/dispatch-action app-atom :web.myaccount.address/delete {:ent/uuid (:ent/uuid address-item)})
            :class (u/bem :icon-link :icon-block-link [:size-small] :tooltip [:top])
            :data-tooltip "Delete"}
           [:i {:class (u/bem :icon [:delete :is-dark :inline])}]
           [:span.hidden-from-view "Delete address"]]]]]])))

(rum/defc addressbook < rum/reactive [app-atom addresses-atom user-address-atom]
  (let [addresses (rum/react addresses-atom)]
    (headings/heading "Addresses" {:type :h2 :size :medium})
    [:table.yc-table
     [:caption.yc-table-caption.hidden-from-view "View your saved addresses"]
     [:colgroup
      [:col]
      [:col {:style {:width "160px"}}]
      [:col {:style {:width "160px"}}]
      [:col]
      [:col]]
     [:thead.yc-thead
      [:tr.yc-tr
       [:th.yc-th {:scope "col"} "Address"]
       [:th
        {:class (u/bem :yc-th [:centered])
         :scope "col"}
        [:span.clip-text.unclip-text--l "Default "]
        "Billing"]
       [:th
        {:class (u/bem :yc-th [:centered])
         :scope "col"}
        [:span.clip-text.unclip-text--l "Default "]
        "Shipping"]
       [:th
        {:class (u/bem :yc-th [:centered])
         :scope "col"} "Options"]]]

     (into
       [:tbody.yc-tbody]
       (map
         (partial address-line app-atom user-address-atom)
         addresses))]))

(rum/defc addresses < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        addresses-atom (rum/cursor-in action-atom [:addresses])
        user-address-atom (rum/cursor-in action-atom [:user])

        addresses-empty?
        (rum/react
          (rum/derived-atom [addresses-atom] :count
            (fn [addresses] (empty? addresses))))]
    [:div
     {:class (u/bem :yc-section [:standard])}
     (headings/heading "Addresses" {:type :h2 :size :medium})

     (cond
       (not addresses-empty?)
       [:div.dashboard
        (addressbook app-atom addresses-atom user-address-atom)
        [:div.dashboard-footer.button-group
         (buttons/button-web "Add an address"
           (merge
             (urlstate/href-props app-atom "myaccount" "addressadd")
             {:style :primary :size :small}))]
        (toaster/loading-overlay app-atom :web.myaccount/addresses)]

       :else
       [:div
        {:class (u/bem :yc-section [:standard] :no-data-wrapper)}
        [:div.no-data-view
         [:p "Store your delivery addresses here for faster checkout."]
         [:div.button-wrapper.button-wrapper--align-center
          {:class (u/bem :button-wrapper [:align-center])}
          (buttons/button-web "Add an address"
            (merge
              (urlstate/href-props app-atom "myaccount" "addressadd")
              {:style :primary :size :small}))]]
        (toaster/loading-overlay app-atom :web.myaccount/addresses)])]))

(defmethod flow/render-screen :web.myaccount/addressbook [app-atom _]
  (awm.common/screen-wrapper app-atom
    (addresses app-atom)))

(defmethod t/transition-open :web.myaccount/addressbook [app-atom _ _]
  (toaster/open-overlay app-atom :web.myaccount/addresses)
  (comms/ajax-get :web.myaccount/addressbook {}))

(defmethod comms/receive :web.myaccount/addressbook [app-atom e]
  (toaster/close-overlay app-atom :web.myaccount/addresses)

  (swap! (cmn/action-cursor app-atom) assoc
    :addresses (:addresses e)
    :user (:user e)))